import { IonButtons, IonMenuButton, IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonItem, IonLabel, useIonRouter, IonIcon, IonImg, useIonViewDidEnter, IonButton, IonCard, IonCardContent, IonItemSliding, IonItemOptions, IonItemOption, IonNote, IonRefresher, IonRefresherContent, RefresherEventDetail, IonBackButton, useIonViewWillEnter } from '@ionic/react';
import { addCircleOutline, alertCircleOutline, checkmarkCircleOutline, checkmarkOutline, closeOutline, helpOutline, warningOutline } from 'ionicons/icons';
import React, { ReactNode, useEffect, useRef, useState } from 'react';
import { Geolocation } from '@capacitor/geolocation';
import { useAppContext } from '../AppProvider';
import { chevronBackOutline } from 'ionicons/icons';
import Alert from '@mui/material/Alert';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Link } from 'react-router-dom';
import { useDeviceContext } from '../components/useDeviceContext';

const SOS: React.FC = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const [btnDisabled, setBtnDisabled] = useState<boolean>(true);
    const [SOSSent, setSOSSent] = useState<boolean>(false);
    
    const { setNetworkStatus, appStatus, appStatusMarkup, getAppStatus, authKey, authenticateMember, authorizedMember, networkStatus, setShowLoader, limits, profiles, settings, locationPerm, locationPermStr, contacts, getContacts, textLogoLoaded, fadeInTextLogo, SWTextLogo, SWFullHorizLogo, SWTextDarkLogo, getTimezones, timezoneName, showToast } = useAppContext();

    const btn = useRef<any>();
    const slideBtn = useRef<any>();

    const router = useIonRouter();
    const deviceCtx = useDeviceContext();

    //
    // Authenticate Member
    //
    useIonViewWillEnter(() => { 
        setShowLoader(true);   
        const authenticate = async () => {
            const appstat = await getAppStatus();
            if (!networkStatus && appstat === 'No') {
                router.push('/connection', 'forward');
            } else {
                const authenticated = await authenticateMember();                        
                if(!authenticated) router.push('/login', 'forward');
            }

            setShowLoader(false);
        };
        authenticate();
    }); 


    //
    // Handle change of Network Status
    //
    useEffect(() => {
            getAppStatus();
    }, [networkStatus]);    


    //
    // Set button disabled status
    //
    useEffect(() => {
        if (limits.contacts >= 0) {
            const fetchData = async () => {
                await getTimezones();
                await getContacts(authorizedMember.memberToken, 'all', limits.contacts);
                setLoading(false)
            }
            fetchData();
        }
    }, [authorizedMember, limits?.contacts]);


    //
    // Set button disabled status
    //
    useEffect(() => {
        if (profiles.contactsActive === 0) setBtnDisabled(true);
        else if (profiles.contactsActive >= 1) setBtnDisabled(false);
    }, [profiles.contactsActive]);


    //
    // Get Current Position
    //
    const getCurrentPosition = async () => {
        try {
            const CurrentPosition = await Geolocation.getCurrentPosition();
            const Coordinates = CurrentPosition.coords;
            return Coordinates;
        } catch (e) {
            return false;
        }
    };


    //
    // Send SOS call
    //
    const sendSOS = async () => {
        setBtnDisabled(true);
        if (btn.current !== undefined) btn.current.innerText = 'Sending the SOS...';
        if (slideBtn.current !== undefined) slideBtn.current.innerText = 'Sending the SOS...';
        let latitude = 0;            
        let longitude = 0; 
        let accuracy = 0; 
        let coords = '';
        try {
            if (locationPerm) {
                let Coordinates = await getCurrentPosition();
                if(Coordinates !== false && Coordinates.latitude !== undefined && Coordinates.longitude !== undefined) {
                    latitude = Coordinates.latitude;
                    longitude = Coordinates.longitude;
                    accuracy = Coordinates.accuracy;
                    coords = latitude + ',' + longitude + ',' + accuracy;
                }
            }

            const formData = new FormData();
            formData.append('mt', authKey.mt);
            formData.append('coords', coords);

            const response = await fetch('https://api.besolowise.com/sos/', {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            
            if(response.ok) {
                const obj = await response.json(); 

                if(obj.success) {
                    if (btn.current !== undefined) btn.current.innerText = 'S.O.S. Was Sent';
                    if (slideBtn.current !== undefined) slideBtn.current.innerText = 'S.O.S. Was Sent';
                    setSOSSent(true);
                    showToast({
                        message: obj.message,
                        duration: 5500,
                        color: 'success',
                    });
                } else {
                    showToast({
                        message: 'An error occured. Please try again.',
                        duration: 3000,
                        color: 'dark',
                    });
                } 
            } else { 
                showToast({
                    message: 'Response Error',
                    duration: 2000,
                    color: 'dark',
                });
            } 
        } catch (e) {
            console.error('Error sending SOS:', e);
        }
    };


    const closeThisSliding = async (ev: React.MouseEvent) => {
        const sliding = (ev.currentTarget as HTMLElement).closest('ion-item-sliding') as HTMLIonItemSlidingElement | null;
        await sliding?.close(); 
    };


    const handleRefresh = (event: CustomEvent<RefresherEventDetail>) => {
        setLoading(true);
        setTimeout(async () => {
            setBtnDisabled(profiles.contactsActive == 0);
            setSOSSent(false);
            btn.current.innerText = 'Send for Help Now!';
            event.detail.complete();
            setLoading(false);
        }, 1500);
    };

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar className='ion-text-center'>
                    <IonButtons slot='start'>
                        <IonBackButton color={'tertiary'}>Back</IonBackButton>
                    </IonButtons>
                    <IonTitle><IonImg className={textLogoLoaded ? 'fade-in' : 'fade-out'} src={settings.theme == '1' ? SWTextDarkLogo : SWFullHorizLogo} onIonImgDidLoad={fadeInTextLogo}></IonImg></IonTitle>
                    <IonButtons slot='end'>
                        <IonMenuButton color={'tertiary'} />
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding account-content-bg">

                <IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>

                {/*<div id="connStatusBar" className={appStatus}>
                    {appStatusMarkup} Connection
                </div>*/}

                <div className='ion-text-center ion-margin-top'>
                    <IonIcon color={'danger'} icon={alertCircleOutline} style={{'fontSize': '70px'}}></IonIcon> 
                    <h1>Emergency SOS</h1>
                </div>                
                
                <div className='ion-padding'>
                    {profiles === undefined || profiles.contactsActive == 0 &&
                    (<><Alert
                        severity="error"
                        icon={<InfoOutlinedIcon fontSize="inherit" />}
                        sx={{
                        borderRadius: 2
                        }}
                    >
                        <p className='ion-no-margin'><em><strong>No Confirmed Contacts:</strong> You must have at least one confirmed SoloWise Contact to enable this feature.</em></p>
                    </Alert>
                    </>)}

                    {profiles !== undefined && profiles.contactsActive >= 1 &&
                    <>
                        <Alert
                            severity="error"
                            icon={<InfoOutlinedIcon fontSize="inherit" />}
                            sx={{
                            borderRadius: 2
                            }}
                        >
                            <p className='ion-no-margin'><em><strong>If you are experiencing a life-threatening emergency, call 911 first.</strong></em></p>
                            <p>This feature requires an internet connection.</p>
                            <p><em>SoloWise will immediately notify all your confirmed emergency contacts about your urgent need for help.</em></p>
                            
                        </Alert>                    
                    </>
                    }
                </div>

                {deviceCtx.useSlideAction 
                    ? <div className='ion-text-center'>
                        <IonItemSliding disabled={btnDisabled} style={{'margin': '20px auto 10px', 'width': '320px'}}>
                            <IonItem className='cursor-pointer' color={SOSSent ? 'success' : 'danger'}>
                                <IonLabel className='ion-text-center' ref={slideBtn}>
                                    <IonIcon icon={chevronBackOutline} style={{verticalAlign: 'sub'}}></IonIcon>                                  
                                    <strong>Slide for SOS</strong>
                                </IonLabel>
                            </IonItem>
                            <IonItemOptions side='end'>
                                <IonItemOption 
                                    color="success" 
                                    expandable
                                    onClick={async (e) => {
                                        await closeThisSliding(e);
                                        sendSOS();
                                    }}
                                >
                                    <IonIcon icon={checkmarkCircleOutline} slot='start'></IonIcon> 
                                    Send SOS NOW
                                </IonItemOption>
                            </IonItemOptions>
                        </IonItemSliding>
                        <IonNote>
                            {!SOSSent && 'First slide left, then tap "Send SOS Now"' }
                        </IonNote>
                        </div>
                    :   <div className='ion-padding' style={{margin: '20px auto', maxWidth: '500px', width: '100%'}}>
                            <IonButton color={SOSSent ? 'success' : 'danger'} disabled={btnDisabled} expand='block' onClick={sendSOS} ref={btn} size='large'>{(profiles === undefined || profiles.contacts == 0) ? 'No Confirmed Contacts' : 'Send for Help Now!'}</IonButton> 
                        </div>
                }


                {SOSSent &&
                    (<IonCard>
                        <IonCardContent className='font-size-med ion-padding ion-text-center'>
                            <IonIcon color={'success'} icon={checkmarkCircleOutline} style={{'fontSize': '70px'}}></IonIcon>
                            <p className='ion-margin-top'>Your emergency contact(s) have been notified.</p>
                            <p className='ion-margin-top'>Someone will be there as soon as possible.</p>
                        </IonCardContent>
                    </IonCard>)
                }

            </IonContent>
        </IonPage>
    );
};

export default SOS;